/**
 * Song Library deep-link (`?trackId=`) helpers.
 * Clear Filter must drop URL + latched form Track ID together — otherwise the
 * server list unfilters while client-side trackIdFilter keeps a single row.
 */

export function stripTrackIdSearchParam(
  searchParams: URLSearchParams,
): URLSearchParams {
  const next = new URLSearchParams(searchParams);
  next.delete("trackId");
  return next;
}

export function clearTrackIdFormFilter<T extends { trackIdFilter?: string }>(
  filters: T,
): T {
  if (filters.trackIdFilter == null || filters.trackIdFilter === "") {
    return filters;
  }
  return { ...filters, trackIdFilter: undefined };
}

/** Client-side Track ID match used by Song Library (TR-… or canonical). */
export function songMatchesTrackIdFilter(
  trackId: string,
  trackIdFilter: string | undefined,
  normalize: (raw: string) => string,
): boolean {
  if (!trackIdFilter) return true;
  return trackId.toLowerCase().includes(normalize(trackIdFilter).toLowerCase());
}
